import React, { useState } from "react";
import { Search } from "lucide-react";
import medicineIcon from "../../../../../../assets/images/medicineIcon.png";
import { OrderedProduct } from "./ReturnMain";

interface SoldProductsProps {
  products: OrderedProduct[];
  onAddProduct: (productId: string) => void;
  maxQuantities: Record<string, number>;
}

const SoldProducts: React.FC<SoldProductsProps> = ({
  products,
  onAddProduct,
  maxQuantities,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredProducts = products.filter((product) =>
    product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-white rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-800">Available Products</h2>
        <div className="relative">
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-2 font-medium text-gray-600">
                Product Name
              </th>
              <th className="text-left py-3 px-2 font-medium text-gray-600">
                Price
              </th>
              <th className="text-left py-3 px-2 font-medium text-gray-600">
                Quantity
              </th>
              <th className="text-left py-3 px-2 font-medium text-gray-600">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.map((product) => (
              <tr
                key={product.inwardStockId}
                className="border-b border-gray-100 hover:bg-gray-50"
              >
                <td className="py-4 px-2">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                      <img
                        src={product.product_image || medicineIcon}
                        alt={product.product_name}
                        className="w-10 h-10 object-contain"
                      />
                    </div>
                    <div>
                      <div className="font-medium text-gray-900">
                        {product.product_name}
                      </div>
                      <div className="text-sm text-gray-500">
                        {product.manufacturer_name}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="py-4 px-2">

                  {product.mrp && (
                    <div className="text-sm text-gray-500 ">
                      ₹ {Number(product.spPerTablet).toFixed(2)}
                    </div>
                  )}
                  <div className="font-medium text-gray-900 line-through">
                    ₹ {Number(product.mrp).toFixed(2)}
                  </div>
                </td>
                <td className="py-4 px-2">
                  <span className="text-gray-900">
                    Ordered: {maxQuantities[product.id] || 0}pcs
                  </span>
                  <div className="text-sm text-gray-500">
                    Available: {product.quantity}pcs
                  </div>
                </td>
                <td className="py-4 px-2">
                  <button
                    onClick={() => onAddProduct(product.inwardStockId)}
                    disabled={maxQuantities[product.id] <= 0}
                    className={`px-3 py-1 bg-white border border-gray-300 rounded-full text-sm hover:bg-gray-50 ${maxQuantities[product.id] <= 0
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                      }`}
                  >
                    Add
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SoldProducts;